import TimeUtils from 'app/utils/time';
import type { InstagramAudioSelection } from 'types/Attachments';
import type { InstagramAudioTrack } from '../types';
import { formatTrackSubtitle } from './formatTrackSubtitle';

export function formatTrackDetails(
  track: Pick<
    InstagramAudioTrack | InstagramAudioSelection,
    'display_artist' | 'ig_username' | 'duration_in_ms'
  >,
): string {
  const duration =
    track.duration_in_ms !== null
      ? TimeUtils.calculateDurationFromMilliseconds(track.duration_in_ms)
      : null;

  return [formatTrackSubtitle(track), duration].filter(Boolean).join(' · ');
}
